import * as React from 'react';
import { SVGProps } from 'react';
const SvgCalendar = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.9996 3.80003H16.9996V2H15.1996V3.80003H8.79961V2.00041H7.00001L6.99961 3.80003H2L2.0004 22.0001H21.9996V3.80003ZM20 20H4V10.7H20V20ZM4 9.00004V5.60003H6.99961V7.00003H8.79961V5.60003H15.1996V7.00003H16.9996V5.60003H20V9.00004H4Z"
      fill="current"
    />
  </svg>
);
export default SvgCalendar;
